<template>
  <div class="foot-message">
    <div class="message-section">
      <el-form
        :model="form"
        ref="formRef"
        :rules="rules"
        label-position="top"
        label-width="0"
        class="contact-form"
      >
        <el-form-item
          style="font-size: 18px"
          :label="$t('system.contact.register.name')"
          prop="name"
          required
        >
          <el-input v-model="form.name" />
        </el-form-item>
        <!-- <el-form-item
          :label="$t('system.contact.register.country')"
          prop="country"
          required
        >
          <el-select v-model="form.country" @change="handleCountryChange">
            <el-option
              v-for="item in countryOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('system.contact.register.mobile')"
          prop="mobile"
          required
        >
          <el-input v-model="form.mobile">
            <template #prepend>
              <span>{{ phonePrefix }}</span>
            </template>
          </el-input>
        </el-form-item> -->

        <el-form-item
          :label="$t('system.contact.register.email')"
          prop="email"
          required
        >
          <el-input v-model="form.email" />
        </el-form-item>

        <el-form-item
          :label="$t('system.contact.register.description')"
          required
          prop="description"
        >
          <el-input v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="submit-btn" type="primary" @click="onSubmit">{{
            $t("system.contact.register.primary")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { countries } from "../../../utils/countries";
import { ElMessage } from "element-plus";
import axios from "../../../utils/axios";
import { ref, computed, reactive } from "vue";
const { t, locale } = useI18n(); // 移动到这里
// 获取 el-form 节点
const formRef = ref();
// 表单数据
const form = reactive({
  name: "",
  company: "",
  country: "",
  city: "",
  address: "",
  mobile: "",
  email: "", // 新增
  type: "",
  source: [],
  password: "",
  confirmPassword: "",
  description: "",
  countryCode: "",
  // code: ""
});
// 表单验证规则
const rules = reactive({
  name: [
    {
      pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
      message: t("system.contact.register.rules.name.pattern"),
      trigger: "blur",
    },
    {
      required: true,
      message: t("system.contact.register.rules.name.required"),
      trigger: "blur",
    },
    {
      min: 2,
      max: 15,
      message: t("system.contact.register.rules.name.length"),
      trigger: "blur",
    },
  ],
  company: [
    {
      pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
      message: t("system.contact.register.rules.company.pattern"),
      trigger: "blur",
    },
    // {
    //   required: true,
    //   message: t("system.contact.register.rules.company.required"),
    //   trigger: "blur"
    // },
    {
      min: 3,
      max: 15,
      message: t("system.contact.register.rules.company.length"),
      trigger: "blur",
    },
  ],
  mobile: [
    {
      pattern: /^[0-9]{1,4}[-\s]?(?:[0-9]{2,4}[-\s]?){1,3}[0-9]{2,4}$/,
      message: t("system.contact.register.rules.mobile.pattern"),
      trigger: "blur",
    },
    {
      required: true,
      message: t("system.contact.register.rules.mobile.required"),
      trigger: "blur",
    },
  ],
  email: [
    {
      pattern:
        /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
      message: t("system.contact.register.rules.email.pattern"),
      trigger: "blur",
    },
    {
      required: true,
      message: t("system.contact.register.rules.email.required"),
      trigger: "blur",
    },
  ],
  country: [
    {
      required: true,
      message: t("system.contact.register.rules.country.required"),
      trigger: "blur",
    },
  ],
  /*
  password: [
    {
      required: true,
      message: t("system.contact.register.rules.password.required"),
      trigger: "blur",
    },
    {
      pattern:
        /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/,
      message: t("system.contact.register.rules.password.pattern"),
      trigger: "blur",
    },
  ],
  confirmPassword: [
    {
      required: true,
      message: t("system.contact.register.rules.confirmpassword.required"),
      trigger: "blur",
    },
    {
      validator: (
        _rules: any,
        value: string,
        callback: (arg0: Error | undefined) => void
      ) => {
        if (value !== form.password) {
          callback(new Error("确认密码与密码不匹配"));
        } else {
          callback();
        }
      },
      trigger: "blur",
    },
  ],
  */
  description: [
    {
      required: true,
      message: t("system.contact.register.rules.description.required"),
      trigger: "blur",
    },
  ],
});
const phonePrefix = ref(countries[0].countryCode);
// 修改 handleCountryChange 函数
const handleCountryChange = (value: string) => {
  const country = countries.find((c) => c.code === value);
  if (country) {
    phonePrefix.value = country.countryCode;
    // 根据语言环境选择要传输的国家名称
    form.country = locale.value === "zh-cn" ? country.zh : country.en;
    form.countryCode = country.countryCode;
  }
};
const onSubmit = () => {
  // 执行表单验证
  formRef.value.validate((valid: any) => {
    if (valid) {
      axios
        .post("/register", form)
        .then((response) => {
          console.log("响应数据:", response); // 添加日志查看响应数据结构
          ElMessage.success("提交成功");
          // 清空表单
          Object.keys(form).forEach((key) => {
            form[key] = "";
          });
          // 重置表单校验状态
          formRef.value.resetFields();
        })
        .catch((error) => {
          console.error("注册失败:", error);
        });
    }
  });
};
</script>

<style scoped lang="scss">
.message-section {
  width: 100%;
}
:deep(.contact-form) {
  .el-form-item {
    margin-bottom: 20px;

    &__label {
      font-size: 14px;
      color: #333;
    }

    &__content {
      margin-left: 0 !important;
    }
  }

  .el-input {
    width: 100%;
  }

  .submit-btn {
    width: 100%;
  }
}
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 15px;

  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .text {
    h4 {
      color: #333;
      font-size: 16px;
      margin-bottom: 5px;
    }

    p {
      color: #666;
      font-size: 14px;
      line-height: 1.5;
    }
  }
}
</style>